export default __webpack_public_path__ + "88af70a5c736b2b320665c0b7c7cf5b5.png";